var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacketStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.5698,
    y: 11.1731,
    width: 2.81616,
    height: 38.0182,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: -1.5,
    width: 2.81616,
    height: 63.3636,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1396,
    y: -1.5,
    width: 2.81616,
    height: 63.3636,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6192,
    cy: 29.8367,
    r: 13.0318,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4253,
    cy: 25.4897,
    rx: 1.51049,
    ry: 1.88812,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.2731,
    cy: 29.6435,
    rx: 1.88812,
    ry: 1.51049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.4253,
    cy: 34.1753,
    r: 1.51049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9573,
    cy: 29.6435,
    r: 1.51049,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6192 42.8686C32.4334 42.8686 26.5874 37.0225 26.5874 29.8367C26.5874 22.6509 32.4334 16.8049 39.6192 16.8049C46.805 16.8049 52.651 22.6509 52.651 29.8367C52.651 37.0225 46.8049 42.8686 39.6192 42.8686ZM39.6192 17.4582C32.7936 17.4582 27.2405 23.0112 27.2405 29.8367C27.2405 36.6623 32.7935 42.2154 39.6191 42.2154C46.4446 42.2154 51.9976 36.6623 51.9976 29.8367C51.9977 23.0112 46.4446 17.4582 39.6192 17.4582ZM39.6192 39.578C34.2479 39.578 29.878 35.2082 29.878 29.8367C29.878 24.4655 34.2479 20.0955 39.6192 20.0955C44.9905 20.0955 49.3604 24.4654 49.3604 29.8367C49.3604 35.208 44.9904 39.578 39.6192 39.578ZM39.6192 20.7489C34.6081 20.7489 30.5312 24.8257 30.5312 29.8368C30.5312 34.848 34.6081 38.9249 39.6192 38.9249C44.6303 38.9249 48.7071 34.8481 48.7071 29.8368C48.7071 24.8257 44.6303 20.7489 39.6192 20.7489ZM39.6192 36.2161C38.5268 36.2161 37.6381 35.3274 37.6381 34.2351C37.6381 33.1427 38.5268 32.2539 39.6192 32.2539C40.7116 32.2539 41.6002 33.1427 41.6002 34.2351C41.6002 35.3274 40.7114 36.2161 39.6192 36.2161ZM39.6192 32.9071C38.887 32.9071 38.2914 33.5029 38.2914 34.2351C38.2914 34.9672 38.887 35.5629 39.6192 35.5629C40.3513 35.5629 40.947 34.9671 40.947 34.2351C40.947 33.5029 40.3513 32.9071 39.6192 32.9071ZM44.0174 31.8178C42.925 31.8178 42.0364 30.9291 42.0364 29.8367C42.0364 28.7443 42.925 27.8556 44.0174 27.8556C45.1098 27.8556 45.9986 28.7443 45.9986 29.8367C45.9986 30.9291 45.1098 31.8178 44.0174 31.8178ZM44.0174 28.5089C43.2852 28.5089 42.6896 29.1047 42.6896 29.8367C42.6896 30.5687 43.2852 31.1645 44.0174 31.1645C44.7496 31.1645 45.3453 30.5687 45.3453 29.8367C45.3453 29.1047 44.7496 28.5089 44.0174 28.5089ZM35.2209 31.8178C34.1286 31.8178 33.2399 30.9291 33.2399 29.8367C33.2399 28.7443 34.1286 27.8556 35.2209 27.8556C36.3133 27.8556 37.202 28.7443 37.202 29.8367C37.202 30.9291 36.3132 31.8178 35.2209 31.8178ZM35.2209 28.5089C34.4888 28.5089 33.8931 29.1047 33.8931 29.8367C33.8931 30.5687 34.4888 31.1645 35.2209 31.1645C35.9531 31.1645 36.5488 30.5687 36.5488 29.8367C36.5488 29.1047 35.9531 28.5089 35.2209 28.5089ZM39.6192 27.4195C38.5268 27.4195 37.6381 26.5308 37.6381 25.4385C37.6381 24.3461 38.5268 23.4574 39.6192 23.4574C40.7116 23.4574 41.6002 24.3461 41.6002 25.4385C41.6002 26.5308 40.7114 27.4195 39.6192 27.4195ZM39.6192 24.1107C38.887 24.1107 38.2914 24.7064 38.2914 25.4385C38.2914 26.1705 38.887 26.7663 39.6192 26.7663C40.3513 26.7663 40.947 26.1705 40.947 25.4385C40.947 24.7064 40.3513 24.1107 39.6192 24.1107Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacketStandard);
export default __webpack_public_path__ + "static/media/placket_standard.b9cce6ac2bb93114f27181c9d8bce246.svg";
export { ForwardRef as ReactComponent };